export enum AuditScanArtifactJoinInfo {
  LEFT = 'left',
  RIGHT = 'right',
}
